import React from 'react';
import { withRouter } from 'react-router-dom';
import { getPathComparison, getProductTypeById } from '@finect/front-resources/Products';
import { withUXPreferences } from '@finect/front-core/withUXPreferences';
import { useTheme } from 'styled-components';
import { Section, Expanded } from '../../Section';
import { TimeseriesChart, ExpandedTimeseriesChart } from '../../Products/Charts';
import { Centered } from './partials';
export var FundTimeseriesChart = function FundTimeseriesChart(_ref) {
  var fund = _ref.fund,
    history = _ref.history,
    _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin,
    uxPreferencesParams = _ref.uxPreferencesParams,
    uxPreferencesFunctions = _ref.uxPreferencesFunctions,
    uxPreferencesProps = _ref.uxPreferencesProps,
    user = _ref.user,
    _ref$isCompact = _ref.isCompact,
    isCompact = _ref$isCompact === void 0 ? false : _ref$isCompact,
    _ref$withComparison = _ref.withComparison,
    withComparison = _ref$withComparison === void 0 ? true : _ref$withComparison;
  var productType = getProductTypeById(fund.subtype);
  var theme = useTheme();
  var handleTimeRangeChange = function handleTimeRangeChange(id) {
    return uxPreferencesFunctions.setParam('timeseriesChartUXTimeRange', id);
  };
  var _uxPreferencesParams$ = uxPreferencesParams.timeseriesChartUXTimeRange,
    timeseriesChartUXTimeRange = _uxPreferencesParams$ === void 0 ? '36M' : _uxPreferencesParams$;
  var ready = !user.isLoggedIn || user.isLoggedIn && !uxPreferencesProps.fetching && uxPreferencesProps.fetched;
  var actions = [{
    action: 'Comparar',
    icon: 'sliders',
    onAction: function onAction() {
      history.push(getPathComparison(theme, productType, [fund]));
    }
  }];
  return React.createElement(Section, {
    id: "rentabilidad-".concat(fund.id),
    bottomMargin: bottomMargin,
    actions: withComparison ? actions : []
  }, React.createElement(Expanded, {
    position: "header"
  }, React.createElement(Centered, null, React.createElement(ExpandedTimeseriesChart, {
    products: [fund]
  }))), React.createElement(TimeseriesChart, {
    ready: ready,
    products: [fund],
    timeRange: timeseriesChartUXTimeRange,
    onTimeRangeChange: handleTimeRangeChange,
    isCompact: isCompact
  }));
};
export default withRouter(withUXPreferences(FundTimeseriesChart));